import * as React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { Chip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useGridApiContext } from "@mui/x-data-grid";
import { Colours } from "../../../../assets/global/Theme-variable";
import { useDrag, useDrop, DndProvider } from 'react-dnd'
import update from 'immutability-helper'
import { HTML5Backend } from 'react-dnd-html5-backend'

const DraggableChip = ({ option, index, value, getTagProps, type, moveChip }) => {
  const { key, ...rest } = getTagProps({ index });
  const ref = React.useRef(null);
  const [{ handlerId }, drop] = useDrop({
    accept: 'DraggableTag',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      }
    },
    hover(item, monitor) {
      if (!ref.current) {
        return
      }
      const dragIndex = item.index
      const hoverIndex = index
      if (dragIndex === hoverIndex) {
        return
      }
      const hoverBoundingRect = ref.current?.getBoundingClientRect()
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      const clientOffset = monitor.getClientOffset()
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }
      moveChip(dragIndex, hoverIndex)
      item.index = hoverIndex
    },
  })
  const [{ isDragging }, drag] = useDrag({
    type: "DraggableTag",
    item: () => {
      return { key, index }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })
  const opacity = isDragging ? 0 : 1
  drag(drop(ref));
  return <Chip
      ref={ref}
      variant="filled"
      data-handler-id={handlerId}
      label={option && option[`${type}_name`]}
      size="medium"
      key={key}
      {...rest}
      onMouseDown={(e) => {
        // Prevent the grid from intercepting the mouse down so drag can start
        e.stopPropagation();
      }}
      deleteIcon={<CloseIcon size={10} />}
      sx={{
		cursor: "pointer",
        borderRadius: "6px",
        backgroundColor: (option?.tag_details?.styling
          ? option?.tag_details?.styling?.colour
          : Colours.gsblue),
          padding: "2px 4px 2px 8px",
      color: "white",
      borderColor: option?.tag_details?.styling
      ? option?.tag_details?.styling?.colour
      : Colours.gsblue,
          fontSize: 10,

      "& svg": {
            fontSize: "14px",
            cursor: "pointer",
            color: "white !important",
            },
            "& .MuiChip-deleteIcon": {
              fontSize: "12px",
            },
        opacity,
      }}
            />
}

export const AutocompleteChipCell = (props) => {
  const [selectedOptions, setSelectedOptions] = React.useState(
    props.value || []
  );
  const { id, field, value, options, type, fieldToSave, fieldToShow } = props;
  const ref = useGridApiContext();
// console.log(value)
  React.useEffect(() => {
    if (value) {
      ref.current.setEditCellValue({
        id,
        field,
        value: selectedOptions.map((val) => val && val[`${type}_ref`]),
      });
      ref.current.stopCellEditMode({ id, field });
    }
  }, [selectedOptions]);

  
    const moveChip = React.useCallback((dragIndex, hoverIndex) => {
      setSelectedOptions((prevCards) =>
        update(prevCards, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, prevCards[dragIndex]],
          ],
        }),
      )
    }, [])

  return (
    <Stack spacing={3} sx={{ width: "100%" }}>
      <DndProvider backend={HTML5Backend}>
      <Autocomplete
        sx={{
          width: "100%",
          "& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none",
            // borderColor: "black",
          },
          "& .MuiInput-root::before .MuiInput-root::hover": {
            border: "none",
          },
        }}
        multiple
        variant="outlined"
        id="tags-standard"
        options={options}
        getOptionKey={(option) => option[`${type}_uid`]}
        getOptionLabel={(option) => option[`${type}_name`]}
        isOptionEqualToValue={(option, value) => {
          if (
            option &&
            option[`${type}_ref`] &&
            value &&
            value[`${type}_ref`]
          ) {
            return (
              parseInt(option[`${type}_ref`]) === parseInt(value[`${type}_ref`])
            );
          }
          return false;
        }}
        value={selectedOptions}
        renderTags={(value, getTagProps) =>
          value?.map((option, index) => {
            return (
              <DraggableChip
                key={option?.[`${type}_uid`] ?? index}
                option={option}
                index={index}
                value={value}
                getTagProps={getTagProps}
                type={type}
                moveChip={moveChip}
              />
            );
          })
        }
        onChange={(e, newValue) => setSelectedOptions(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            InputProps={{ ...params.InputProps, disableUnderline: true }}

            // label="Multiple values"
            // placeholder="Favorites"
          />
        )}
      />
      </DndProvider>
    </Stack>
  );
};
